const IconError: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    width='16'
    viewBox='0 0 24 24'
    focusable='false'
    role='presentation'
    fill='currentColor'
    {...props}
    className={`icon icon-error${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
      fill=''
    ></path>
  </svg>
);
export default IconError;
